/*jshint camelcase: false*/
/*global define, unescape, escape*/
define('legacy/campaign/campaign',['jquery', 'all/jquery/jquery.cookie', 'legacy/data-TEMP', 'legacy/yui-2.9.0-combo', 'legacy/navigation'], function($) {
	'use strict';

	// Methods for campaign popup navigation
	function CampaignObject(id, header, message, link, resource, openNewUrl, topHeader) {
		this.id = id;
		this.header = header;
		this.message = message;
		this.link = link;
		this.resource = resource;
		this.open_new_url = openNewUrl;
		this.topHeader = topHeader;
	}

	var campaignCounter = 0;

	// get next campaign on popup if exists
	function getNext(id, header, message, link, resource, openNewUrl) {

		var idArray = id.split(',');
		var headerArray = unescape(header).split('§');
		var messageArray = unescape(message).split('§');
		var linkArray = link.split('§');
		var resourceArray = resource.split('§');
		var openNewUrlArray = openNewUrl.split(',');

		campaignCounter++;

		if (campaignCounter === headerArray.length) {
			campaignCounter = 0;
		}

		document.getElementById('campaign_header').innerHTML = headerArray[campaignCounter];
		document.getElementById('campaign_message').innerHTML = messageArray[campaignCounter];
		document.getElementById('campaign_link').href = linkArray[campaignCounter];

		if (openNewUrlArray[campaignCounter] === 'true') {
			document.getElementById('campaign_link').setAttribute('target', '_blank');
		}
		else {
			document.getElementById('campaign_link').removeAttribute('target');
		}

		document.getElementById('campaign_resource').src = resourceArray[campaignCounter];
		document.getElementById('campaign_number').innerHTML = (campaignCounter + 1) + '/' + headerArray.length;
		document.getElementById('campaign_link').setAttribute('onclick', 'campaign.closeCampaignPopup(\'' + idArray[campaignCounter] + '\');');
	}

	// get previous campaign from popup
	function getPrevious(id, header, message, link, resource, open_new_url) {

		var idArray = id.split(',');
		var headerArray = unescape(header).split('§');
		var messageArray = unescape(message).split('§');
		var linkArray = link.split('§');
		var resourceArray = resource.split('§');
		var open_new_urlArray = open_new_url.split(',');

		campaignCounter--;

		if (campaignCounter < 0) {
			campaignCounter = headerArray.length - 1;
		}

		document.getElementById('campaign_header').innerHTML = headerArray[campaignCounter];
		document.getElementById('campaign_message').innerHTML = messageArray[campaignCounter];
		document.getElementById('campaign_link').href = linkArray[campaignCounter];

		if (open_new_urlArray[campaignCounter] === 'true') {
			document.getElementById('campaign_link').setAttribute('target', '_blank');
		}
		else {
			document.getElementById('campaign_link').removeAttribute('target');
		}

		document.getElementById('campaign_resource').src = resourceArray[campaignCounter];
		document.getElementById('campaign_number').innerHTML = (campaignCounter + 1) + '/' + headerArray.length;
		document.getElementById('campaign_link').setAttribute('onclick', 'campaign.closeCampaignPopup(\'' + idArray[campaignCounter] + '\');');
	}

	function closeCampaignPopup(popupCampaignIds) {

		// add filtered popup campaigns
		if (!document.getElementById('terms').checked) {
			var c_value = $.cookie('c_popup_campaign');
			var elem = popupCampaignIds.split(',');

			var popupCampaignId = '';

			for (var i = 0; i < elem.length; i++) {
				if (i > 0 && popupCampaignId.length > 0) {
					popupCampaignId += ',';
				}
				popupCampaignId += elem[i];
			}

			if (c_value === undefined || c_value === 'undefined' || c_value.length === 0 || c_value === null) {
				c_value = popupCampaignId;
			}
			else {
				c_value += ',' + popupCampaignId;
			}

			$.removeCookie('c_popup_campaign');
		}

		window.parent.modalPanel.hide();
		campaignCounter = 0;
	}

	function showCampaignPopup(campaignArray, popupCampaignNext, popupCampaignPrevious, popupCampaignShowAgain, popupCampaignButtonOpenLink, popupCampaignCancel) {

		if (campaignArray.length > 0) {

			var popupCampaignIdArray = [];
			var headerArray = [];
			var messageArray = [];
			var linkArray = [];
			var resourceArray = [];
			var open_new_urlArray = [];
			var topHeaderArray = [];

			for (var i = 0; i < campaignArray.length; i++) {

				popupCampaignIdArray.push(campaignArray[i].id);
				headerArray.push(campaignArray[i].header);
				messageArray.push(campaignArray[i].message);
				linkArray.push(campaignArray[i].link);
				resourceArray.push(campaignArray[i].resource);
				open_new_urlArray.push(campaignArray[i].open_new_url);
				topHeaderArray.push(campaignArray[i].topHeader);
			}

			var switchpopup = '<div id="switchpopup"><a id="next"  href="#" onclick="campaign.getNext(\'' + popupCampaignIdArray.toString() + '\',\'' + escape(headerArray.join('§')) + '\',\'' + escape(messageArray.join('§')) + '\',\'' + linkArray.join('§') + '\',\'' + resourceArray.join('§') +
				'\',\'' + open_new_urlArray.toString() + '\');return false;" >' + popupCampaignNext + '</a><p id="campaign_number">1/' + campaignArray.length + '</p><a id="previous" href="#" onclick="campaign.getPrevious(\'' + popupCampaignIdArray.toString() + '\',\'' +
				escape(headerArray.join('§')) + '\',\'' + escape(messageArray.join('§')) + '\',\'' + linkArray.join('§') + '\',\'' + resourceArray.join('§') + '\',\'' + open_new_urlArray.toString() + '\');return false;" >' + popupCampaignPrevious + '</a></div>';

			var popupBody = '<div class="popup-container" style="width:380px">' + '<h3 id="campaign_header">' + headerArray[0] + '</h3>' + '<img id="campaign_resource" src="' + resourceArray[0] +
				'" width="100" height="100" border="0" alt="" />' + '<div class="bread"><p id="campaign_message">' + messageArray[0] + '</p></div>' +
				'<dl class="checkbox"><dt></dt><dd><input type="checkbox" name="terms" id="terms" value="yes" /></dd><dd><label for="terms">' + popupCampaignShowAgain + '</label></dd></dl>' + '<ul class="pc-buttons">';

			if (open_new_urlArray[0] === 'true') {
				popupBody += '<li><a id="campaign_link" href="' + linkArray[0] + '" class="ui-button size-30 color-primary" target="_blank" onclick="campaign.closeCampaignPopup(\'' + popupCampaignIdArray[0] + '\');"><span>' + popupCampaignButtonOpenLink + '</span></a></li>';
			} else {
				popupBody += '<li><a id="campaign_link" href="' + linkArray[0] + '" class="ui-button size-30 color-primary" onclick="campaign.closeCampaignPopup(\'' + popupCampaignIdArray[0] + '\');"><span>' + popupCampaignButtonOpenLink + '</span></a></li>';
			}

			popupBody += '<li><a id="campaign_close" href="#" class="ui-button size-30 color-primary" onclick="campaign.closeCampaignPopup(\'' + popupCampaignIdArray + '\');return false;""><span>' + popupCampaignCancel + '</span></a></li></ul>';

			// previous next support added if there are more promotions available
			if (campaignArray.length > 1) {
				popupBody += switchpopup;
			}

			var popupHeader = topHeaderArray[0];

			window.top.showModalPanel(popupHeader, popupBody, null, '420px', null, false, true);
			window.top.getTopWindowFocus();
		}
	}

	return {
		showCampaignPopup: showCampaignPopup,
		getPrevious: getPrevious,
		getNext: getNext,
		closeCampaignPopup: closeCampaignPopup,
		CampaignObject: CampaignObject
	};

});

